enum FileContentType {
  Floorplan = 1,
  Contract = 2,
  TitleDeed = 3,
  Other = 4,
  SheetPlan = 5,
  Product = 6,
  Note = 7,
  Task = 8,
  CustomerProfile = 9,
  TaskComment = 10,
  Category = 11,
  BlogPost = 12,
  News = 13,
  SpecificationAttributeDisplay = 14,
  Default = 15,
  Quiz = 16,
  Guide = 17,
  Video = 18,
  Audio = 19,
}

export default FileContentType;
